import { getHttpsUrl, getQuery } from "./";
/**
 * 判断是否是文档域名
 */

export function isTDocsUrl(url) {
  return /^http(s)?:\/\/docs\.qq\.com/.test(url);
}
/**
 * 获取一个多帐号的 url，这个内部使用
 * @param {string} url
 */

export function getRealMultiUrl(theUrl) {
  var url = getHttpsUrl(theUrl);
  var urlUserIndex = getQuery('u', url); // url中已经有u参数或者url为非腾讯文档链接

  if (!isTDocsUrl(url) || urlUserIndex !== '') {
    return url;
  } // 获取u参数值


  var userIndex = getMultiUserIndex(); // 无法获取u参数值则直接返回

  if (!userIndex) {
    return url;
  }

  var parsedUrl = new URL(url);
  var protocol = parsedUrl.protocol,
      host = parsedUrl.host,
      pathname = parsedUrl.pathname,
      search = parsedUrl.search,
      hash = parsedUrl.hash;

  if (search) {
    url = "".concat(protocol, "//").concat(host).concat(pathname).concat(search, "&u=").concat(userIndex).concat(hash);
  } else {
    url = "".concat(protocol, "//").concat(host).concat(pathname, "?u=").concat(userIndex).concat(hash);
  }

  return url;
}
/**
 * 获取一个多帐号登录的 url ,这个对外暴露，
 * @param {string} url
 */

export function getMultiUrl(url) {
  return getRealMultiUrl(url);
}
/**
 * 获取当前的 u，没有填 0
 */

export function getMultiUserIndex() {
  var _ref = window,
      global_multi_user = _ref.global_multi_user;
  var _window = window,
      nowUserIndex = _window.nowUserIndex; // 默认取插到页面中到uid，没有的话填-1.

  return nowUserIndex || (global_multi_user === null || global_multi_user === void 0 ? void 0 : global_multi_user.nowUserIndex) || getQuery('u') || '';
}